import classNames from 'classnames';
import React, { useRef } from 'react';
import closeIcon from '../../icons/non-prefilled/16x16/clear.svg';
import { IconButton } from '../Button';
import * as styles from './PopOverContainer.module.scss';

interface PopOverContainerProps {
  close?: () => void;
  overflow?: 'visible' | 'auto';
  title?: string;
  width?: 'regular' | 'auto' | 'wide';
  fullHeight?: boolean;
  noPadding?: boolean;
  children:
    | React.ReactNode
    | ((args: { scrollToBottom: () => void }) => React.ReactNode);
}

const PopOverContainer = ({
  children,
  close,
  width = 'regular',
  overflow = 'auto',
  title,
  fullHeight,
  noPadding,
}: PopOverContainerProps) => {
  const scrollElementRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (scrollElementRef.current) {
      scrollElementRef.current.scrollTop =
        scrollElementRef.current.scrollHeight;
    }
  };

  const inner =
    typeof children === 'function'
      ? children({
          scrollToBottom,
        })
      : children;

  return (
    <div
      className={classNames(styles.popOverContainer, {
        [styles.widthAuto]: width === 'auto',
        [styles.widthWide]: width === 'wide',
        [styles.maxHeightFull]: fullHeight,
      })}
    >
      <div className={styles.popOverContentWrapper}>
        {title && (
          <div className={styles.popOverContainerHeader}>
            <div className={styles.popOverContainerTitle}>{title}</div>
            <IconButton
              className={styles.popOverContainerClose}
              onClick={close}
              applyNegativeMargin
              aria-label="Close"
            >
              {closeIcon}
            </IconButton>
          </div>
        )}
        <div
          className={classNames(styles.popOverContainerContent, {
            [styles.overflowVisible]: overflow === 'visible',
          })}
          ref={scrollElementRef}
        >
          {noPadding ? (
            inner
          ) : (
            <div className={styles.popOverContainerContentInner}>{inner}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopOverContainer;
